import ReactGridLayout from "react-grid-layout";
import { ChartType, DashboardChartConfig, DashboardEditConfig, DashboardFilterConfigType } from "../types";

export const ORGANIZATION_DASHBOARD_DEFAULT_LG_LAYOUT = [
	{ i: "ALERTS", x: 0, y: 0, w: 1, h: 0 },
	{ i: "CLIENT_DETAILS", x: 0, y: 0, w: 1, h: 19 },
	{ i: "CALL_RECORDER", x: 0, y: 19, w: 1, h: 19 },
	{ i: "LIVE", x: 0, y: 38, w: 1, h: 43 },
	{ i: "SALES_ADVANCED", x: 1, y: 0, w: 2, h: 8 },
	{ i: "PAYMENT", x: 1, y: 8, w: 1, h: 9 },
	{ i: "PRODUCT", x: 1, y: 17, w: 1, h: 8 },
	{ i: "CATEGORY", x: 2, y: 8, w: 1, h: 9 },
	{ i: "SALES", x: 2, y: 17, w: 1, h: 8 },
];

export const USER_DASHBOARD_DEFAULT_LG_LAYOUT = [
	{ i: "CLIENT_DETAILS", x: 0, y: 0, w: 1, h: 19 },
	{ i: "SALES_ADVANCED", x: 1, y: 0, w: 2, h: 8 },
	{ i: "PAYMENT", x: 1, y: 8, w: 1, h: 9 },
	{ i: "PRODUCT", x: 1, y: 17, w: 1, h: 8 },
	{ i: "CATEGORY", x: 2, y: 8, w: 1, h: 9 },
	{ i: "SALES", x: 2, y: 17, w: 1, h: 8 },
];

export const USER_DASHBOARD_GENERAL_SM_LAYOUT = [{ i: "CLIENT_DETAILS", x: 0, y: 0, w: 1, h: 9 }];

export const DASHBOARD_EXTENDED_SM_LAYOUT = [
	{ i: "SALES_ADVANCED", x: 0, y: 0, w: 1, h: 9 },
	{ i: "PAYMENT", x: 0, y: 9, w: 1, h: 9 },
	{ i: "PRODUCT", x: 0, y: 18, w: 1, h: 9 },
	{ i: "CATEGORY", x: 0, y: 27, w: 1, h: 9 },
	{ i: "SALES", x: 0, y: 36, w: 1, h: 9 },
];

export const ORGANIZATION_DASHBOARD_GENERAL_SM_LAYOUT = [
	{ i: "ALERTS", x: 0, y: 9, w: 1, h: 9 },
	{ i: "CLIENT_DETAILS", x: 0, y: 18, w: 1, h: 9 },
	{ i: "CALL_RECORDER", x: 0, y: 18, w: 1, h: 9 },
	{ i: "LIVE", x: 0, y: 36, w: 1, h: 9 },
];

export const ORDER_OF_BASIC_DASHBOARD_ITEMS = [
	"ALERTS",
	"CLIENT_DETAILS",
	"LIVE",
	"SALES_ADVANCED",
	"PAYMENT",
	"PRODUCT",
	"CATEGORY",
	"SALES",
];

// TODO: Remove on draggable mobile dashboard feature apply and improve mobile dashboard grid item z-index logic
export const REVERSED_ORDER_OF_DASHBOARD_MOBILE_ITEMS = [...ORDER_OF_BASIC_DASHBOARD_ITEMS].reverse();

export const DASHBOARD_GRID_LAYOUT_ROW_HEIGHT = 10;
export const DASHBOARD_GRID_LAYOUT_MARGIN_VALUE = 16;

export const getDashboardSegmentNonMobileConfigForSegment = (
	layoutConfig: ReactGridLayout.Layout[] | Omit<ReactGridLayout.Layout, "w" | "h">[]
) => {
	return layoutConfig.map((gridItem) => {
		const { i, x, y } = gridItem;

		return { i, x, y };
	});
};

export const DEFAULT_DASHBOARD_SEGMENT_VALUE: {
	dashboardEdit: DashboardEditConfig<"w" | "h">;
	chartsConfig: DashboardChartConfig;
	filtersConfig: DashboardFilterConfigType;
} = {
	chartsConfig: {
		reportCategory: {
			type: ChartType.HORIZONTAL_BAR,
			range: "DAY_OF_WEEK",
			aggregate: "total_money",
		},
		reportPayment: {
			type: ChartType.VERTICAL_BAR,
			range: "DAY_OF_WEEK",
			aggregate: "total_money",
		},
		reportProduct: {
			type: ChartType.BOX,
			range: "DAY_OF_WEEK",
			aggregate: "total_money",
		},
		reportSales: {
			type: ChartType.BOX,
			range: "DAY_OF_WEEK",
			aggregate: "total_money",
		},
		reportSalesAdvanced: {
			type: ChartType.LINE,
			range: "DAY_OF_WEEK",
			aggregate: "total_money",
		},
	},
	dashboardEdit: {
		mobileGridConfig: {
			general: [],
			extended: [],
		},
		nonMobileGridConfig: [],
	},
	filtersConfig: {
		selectedFilter: {
			dateRange: "today",
		},
	},
};

export const DASHBOARD_RESOURCE_TYPE = "DASHBOARD_CONFIG";
export const GROUP_DASHBOARD_RESOURCE_TYPE = "GROUP_DASHBOARD_CONFIG";
